import ExtraItem from './ExtraItem';
import PropTypes from 'prop-types';

import { getProduct } from '/services/products';
import { useEffect } from 'react';

const ExtraItems = ({
	extraItems,
	extraItemsConfig,
	packConfig,
	setExtraItems,
	updatePackConfig,
}) => {
	useEffect(() => {
		const fetchExtraItems = async () => {
			const promises = extraItemsConfig.map((extraItemConfig) => {
				return getProduct(extraItemConfig.handle);
			});

			const extraItemsProducts = await Promise.all(promises);

			if (extraItemsProducts) {
				setExtraItems(extraItemsProducts);
			}
		};

		if (extraItemsConfig) {
			void fetchExtraItems();
		}
	}, [extraItemsConfig]);

	const selectExtraItem = (products) => {
		updatePackConfig('selectedExtras', products);
	};

	if (!extraItems || extraItems.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-col items-center justify-center">
			{extraItems.map((extraItem, extraItemIndex) => {
				return (
					<div className="flex flex-col justify-center" key={extraItemIndex}>
						<ExtraItem
							extraItem={extraItem}
							onSelect={selectExtraItem}
							selectedExtras={packConfig?.selectedExtras || []}
						/>
					</div>
				);
			})}
		</div>
	);
};

ExtraItems.propTypes = {
	extraItems: PropTypes.array,
	extraItemsConfig: PropTypes.array,
	packConfig: PropTypes.object,
	setExtraItems: PropTypes.func,
	updatePackConfig: PropTypes.func,
};

export default ExtraItems;
